import { BestiesReportingPage } from "@features/BestiesOnboarding/BestiesReportingPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/besties/$siteId/reporting")({
  beforeLoad: ({ context, params }) => {
    if (context.auth.user?.org_type !== "queen_one") {
      throw redirect({
        to: "/besties/$siteId",
        params: { siteId: params.siteId },
      });
    }
  },
  component: BestiesReportingPage,
});
